<div *ngIf="toast && toast.content" [innerHTML]="toast.content" [class]="classes"></div>


// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/formelement.toast.component.ts.FormElementComponentToast.html